import { render, staticRenderFns } from "./manualdiolg.vue?vue&type=template&id=2b6df73d&scoped=true&"
import script from "./manualdiolg.vue?vue&type=script&lang=js&"
export * from "./manualdiolg.vue?vue&type=script&lang=js&"
import style0 from "./manualdiolg.vue?vue&type=style&index=0&id=2b6df73d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6df73d",
  null
  
)

export default component.exports